import { render, staticRenderFns } from "./OrderEditContents.vue?vue&type=template&id=32f1e08a&scoped=true"
import script from "./OrderEditContents.vue?vue&type=script&lang=js"
export * from "./OrderEditContents.vue?vue&type=script&lang=js"
import style0 from "./OrderEditContents.vue?vue&type=style&index=0&id=32f1e08a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f1e08a",
  null
  
)

export default component.exports